import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { useLocale } from "@admin/app/locale";
import { Button, buttonClass, PageState } from "@/shared/rd";
import { usePageTitle } from "./page-title";

/**
 * The canvas's "You're offline" board. Shown over the page, not instead of
 * it: the page stays mounted underneath, so a half-filled form survives.
 */
export function OfflineState() {
  const t = useTranslations();
  const s = keys.shell;
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    if (!checking) return;
    const id = window.setTimeout(() => setChecking(false), 1400);
    return () => window.clearTimeout(id);
  }, [checking]);

  return (
    <PageState
      illustration="offline"
      tone="red"
      pill={t(s.offlinePill)}
      title={t(s.offlineTitle)}
      sub={t(s.offlineSub)}
      actions={
        <Button variant="primary" size="lg" disabled={checking} onClick={() => setChecking(true)}>
          {checking ? t(s.offlineChecking) : t(s.retry)}
        </Button>
      }
    />
  );
}

/** Any admin address no route matches. */
export function NotFoundPage() {
  const t = useTranslations();
  const locale = useLocale();
  const s = keys.shell;
  usePageTitle(t(s.notFoundPage));
  return (
    <PageState
      illustration="admin-not-found"
      tone="purple"
      eyebrow={t(s.notFoundEyebrow)}
      title={t(s.notFoundTitle)}
      sub={t(s.notFoundSub)}
      actions={
        <>
          <Link to={`/${locale}/admin`} className={buttonClass("primary", "lg")}>
            {t(s.goToDashboard)}
          </Link>
          <Link to={`/${locale}/admin/stores`} className={buttonClass("secondary", "lg")}>
            {t(keys.admin.onlineStoresTitle)}
          </Link>
        </>
      }
    />
  );
}
